import clsx from 'clsx';

export type PillVariant = 'surface-l0' | 'surface-l3' | 'surface-l4';

type PillProps = {
  variant?: PillVariant;
  children: React.ReactNode;
  className?: string;
};

const variantStyles: Record<PillVariant, string> = {
  'surface-l0': 'bg-surface-l0 border-color-on-surface-variant text-color-on-surface-variant',
  'surface-l3': 'bg-surface-l3 border-color-on-surface-variant text-color-on-surface-variant',
  'surface-l4': 'bg-surface-l4 border-color-on-surface-variant text-color-on-surface-variant',
};

export function Pill({ variant = 'surface-l3', children, className }: Readonly<PillProps>) {
  return (
    <span className={clsx('py-4 px-12 rounded-full text-sm font-medium border', variantStyles[variant], className)}>
      {children}
    </span>
  );
}
